module.exports = __webpack_public_path__ + "static/media/left_leaf.ea04e234.png";